import { IHttp } from '../http/types'
import { BaseApi } from './baseApi'

export class ATCApi extends BaseApi {
  constructor(http: IHttp, baseUrl: string) {
    super(http, baseUrl)
  }
}
